export default "__VITE_ASSET__BNsVuubJ__"